<template>
  <div class="row">
    <div class="col-12">
      <table class="table table-bordered doctor-single">
        <tbody>
          <tr>
            <td v-if="!editIndex">
              <div class="doctor-education-element">
                <i class="fa fa-graduation-cap" aria-hidden="true"></i> 
                <span>{{dataset}} ( Email หลัก )</span>
              </div>
            </td>
            <td class="edit-element" v-if="!editIndex"><i class="fa fa-pencil-square-o" @click="editData()"></i></td>
            <td v-if="editIndex">
              <div class="doctor-education-input">
                <input type="text" class="form-control" ref="editData" v-model="currentDataset" v-on:blur="hideInput()">
                <div class="confirm">
                  <button class="btn btn-success" @click="saveData()">{{$t('action_message.ok')}}</button>
                </div>
              </div>
            </td>
            <td class="edit-element" v-if="editIndex"><i class="fa fa-pencil-square-o"></i></td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
export default {
  name: 'doctorSingleInput',
  props: {
    dataset: String,
    description: String
  },
  data () {
    return {
      editIndex: false,
      currentDataset: this.dataset,
      prevDataset: this.dataset
    }
  },
  methods: {
    validEmail: function (email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    hideInput () {
      if (this.validEmail(this.currentDataset)) {
        this.$emit('update:dataset', this.currentDataset)
      } else {
        this.currentDataset = this.prevDataset
      }
      this.dataset = this.prevDataset
      this.editIndex = false
    },
    saveData (index, $event) {
      // save data if the length > 1
      this.$emit('update:dataset', this.currentDataset)
      this.editIndex = false
    },
    editData () {
      this.editIndex = true
      // Focus on the input
      let focusDelay = 300
      let refs = this.$refs
      setTimeout(function () {
        refs.editData.focus()
      }, focusDelay)
    }
  }
}
</script>

<style lang="less">
.doctor-single{

  background-color: #f3f3f3;
  margin-bottom: 0px;

  td{
    border: 1px solid #dde6ea;
  }

  .edit-element{
    width: 50px;
  }

  i {
    color: #555;
  }

  .doctor-education-input{
    .confirm {
      text-align: right;
      margin: 5px 0 0 0;
    }
  }

  .doctor-education-element{
    display: flex;
    i {
      margin: 0 5px;
    }
  }
}
.doctor-education-add{
  padding: 10px 20px;
  border: 1px solid #ddd;
  margin-bottom: 10px;
  border-radius: 5px;

  span{
    float: left;
    padding: 12px 0;
    font-weight: bold;
    font-size: 16px;
    color: #bababa;
  }
  button{
    float: right;
  }

  .btn-add-edu{
    border-radius: 5px;
    color: #fff;
    background-color: #4e9666;
    font-size: 16px;
  }
}
.doctor-eduication-ex{
  color: #bababa;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// DoctorSingleInput.vue?68b91b1a